import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState } from './types';

// The initial state of the Notifications container
export const initialState: ContainerState = {
  data: {
    open: false,
    message: '',
    severity: '',
  },
};

const notificationAlertSlice = createSlice({
  name: 'notificationAlertState',
  initialState,
  reducers: {
    addNotification(state, action: PayloadAction<any>) {
      state.data = action.payload;
    },
    removeNotification(state) {
      state.data = { open: false, message: '', severity: '' };
    },
  },
});

export const {
  actions: notificationAlertActions,
  reducer,
  name: sliceKey,
} = notificationAlertSlice;
